import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
	return (
		<footer className="footer">
			<div className="container">
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
					<div>
						<strong>APEX SPECIALTY CONTRACTING LLC</strong><br />
						<span className="helper">183 Highland Rd, Tarpon Springs, FL 34689</span><br />
						<span className="helper">Email: <a href="mailto:info@appexconnecthub.com">info@appexconnecthub.com</a> • Support: <a href="mailto:support@appexconnecthub.com">support@appexconnecthub.com</a></span>
					</div>
					<div className="legal">
						<Link to="/privacy">Privacy</Link>
						<Link to="/terms">Terms</Link>
						<Link to="/sms-policy">SMS Terms</Link>
						<Link to="/opt-out">Opt-Out</Link>
						<Link to="/business-verification">Business Verification</Link>
						<Link to="/contact">Contact</Link>
					</div>
				</div>
				<p className="helper" style={{ marginTop: 12 }}>
					By providing your phone number, you consent to receive SMS messages from APEX SPECIALTY CONTRACTING LLC related to service updates,
					scheduling, and project communication. Message frequency varies. Message and data rates may apply. Reply STOP to unsubscribe. Reply HELP for help.
				</p>
				<p className="helper" style={{ marginTop: 12 }}>
					© {new Date().getFullYear()} Appex Connect Hub. We are not a lender and do not make credit decisions.
				</p>
			</div>
		</footer>
	);
}

export default Footer;


